import React, { useState, useEffect, useContext } from "react";
import {
  Col,
  Form,
  Row,
  Select,
  Radio,
  DatePicker,
  Tooltip,
  Spin,
  Button,
} from "antd";
import moment from "moment";
import axios from "axios";
import { Bar, BarChart, CartesianGrid, Legend, XAxis, YAxis } from "recharts";
import { professionalAction } from "../../_actions";
import { FileImageOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { connect } from "react-redux";
import { LanguageContext } from "../../context/LanguageContext";
import { roleAction } from "../../_actions/roleby.action";
import { adminService } from "../../_services/admin.service";

const { Option } = Select;

const { RangePicker } = DatePicker;

const AnalyticalDashboard = (props) => {
  const { t } = useContext(LanguageContext);
  const timeRange = [
    t("today"),
    t("monthly"),
    t("six_months"),
    t("one_year"),
    t("all"),
  ];
  const options = [
    {
      value: "पो स्टे हद्दीतील आरोपी",
      label: t("info_within_police_station_limits"),
    },
    {
      value: "पो स्टे नी भरलेली माहिती",
      label: t("data_entered_by_police_station"),
    },
    // { value: "एकुण २ प्लस आरोपी", label: t("total_2_plus_accused") },
    { value: "एकुण प्रतिबंधक कारवाई", label: t("total_preventive_actions") },
    { value: "गुन्हा रजिस्टर", label: t("guna_register") },
    { value: "अटक रजिस्टर", label: t("arrest_register") },
    { value: "नोटीस रजिस्टर", label: t("notice_register") },
    { value: "ऐप वापरकर्ते", label: t("app_users") },
    { value: "गस्त", label: t("patrol") },
  ];
  const [form] = Form.useForm();

  const [dateRange, setDataRange] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setendDate] = useState();

  const [reportType, setReportType] = useState(options[0]?.value || "");
  const [selectedValue, setSelectedValue] = useState(t("today"));
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!startDate & !endDate) {
      fetchData();
    }
  }, [selectedValue, reportType]);

  useEffect(() => {
    if (startDate & endDate) {
      dataRage();
    }
  }, [selectedValue, reportType, startDate, endDate]);

  const [totalCount, setTotalCount] = useState();
  const fetchData = async () => {
    setLoading(true);
    setStartDate();
    setendDate();
    const { cityId } = props.user;
    let payload =
      props.user.role === "4"
        ? { cityId: cityId, label: "" }
        : { districtId: props.user.map_districtId, label: "" };
    let payload1 =
      props.user.role === "4"
        ? { cityId: cityId, label: "" }
        : { districtId: props.user.map_districtId, label: "" };

    switch (selectedValue) {
      case t("today"):
        payload = {
          ...payload,
          label: "daily",
          date:
            reportType === "अटक रजिस्टर"
              ? moment()
              : moment().format("YYYY-MM-DD"),
        };
        break;
      case t("monthly"):
        payload = {
          ...payload,
          label: "month",
          month: moment().month() + 1,
          year: moment().year(),
        };
        break;
      case t("six_months"):
        payload = {
          ...payload,
          label: "month-between",
          start_year: moment().subtract(6, "months").year(),
          month_start: moment().subtract(6, "months").month() + 1,
          end_year: moment().year(),
          month_end: moment().month() + 1,
        };
        break;

      case t("one_year"):
        payload = { ...payload, label: "year", year: moment().year() };
        break;
      case t("all"):
        payload = { ...payload, label: "all" };
        break;
      default:
        break;
    }
    switch (selectedValue) {
      case t("today"):
        payload1 = {
          ...payload1,
          label: "daily",
          date:
            reportType === "अटक रजिस्टर"
              ? moment()
              : moment().format("YYYY-MM-DD"),
        };
        break;
      case t("monthly"):
        payload1 = {
          ...payload1,
          label: "month",
          month: moment().month() + 1,
          year: moment().year(),
        };
        break;
      case t("six_months"):
        payload1 = {
          ...payload1,
          label: "month-between",
          start_date:
            reportType === "अटक रजिस्टर"
              ? moment().subtract(6, "months")
              : moment().subtract(6, "months").format("YYYY-MM-DD"),
          end_date:
            reportType === "अटक रजिस्टर"
              ? moment()
              : moment().format("YYYY-MM-DD"),
          end_year: moment().year(),
          month_end: moment().month() + 1,
        };
        break;

      case t("one_year"):
        payload1 = { ...payload1, label: "year", year: moment().year() };
        break;
      case t("all"):
        payload1 = { ...payload1, label: "all" };
        break;
      default:
        break;
    }

    try {
      let response;
      if (reportType === "पो स्टे हद्दीतील आरोपी") {
        if (props.user.role === "4") {
          response = await professionalAction.filledPoliceStationDaily(payload);
        } else {
          response = await roleAction.filledPoliceStationDailyByRole(payload);
        }
      } else if (reportType === "पो स्टे नी भरलेली माहिती") {
        if (props.user.role === "4") {
          response = await professionalAction.notFilledPoliceStationDaily(
            payload
          );
        } else {
          response = await roleAction.notFilledPoliceStationDailyByRole(
            payload
          );
        }
      } else if (reportType === "एकुण २ प्लस आरोपी") {
        if (props.user.role === "4") {
          response = await professionalAction.totaltwoplusCount(payload1);
        } else {
          response = await roleAction.totaltwoplusCountByRole(payload1);
        }
      } else if (reportType === "एकुण प्रतिबंधक कारवाई") {
        if (props.user.role === "4") {
          response = await professionalAction.preventionActionCount(payload);
        } else {
          response = await roleAction.preventionActionCountByRole(payload);
        }
      } else if (reportType === "गस्त") {
        if (props.user.role === "4") {
          response = await professionalAction.surveillanceCount(payload);
        } else {
          response = await roleAction.surveillanceCountByRole(payload);
        }
      } else if (reportType === "ऐप वापरकर्ते") {
        if (props.user.role === "4") {
          response = await professionalAction.totalappuserCount(payload);
        } else {
          response = await roleAction.totalappuserCountByRole(payload);
        }
      } else if (reportType === "नोटीस रजिस्टर") {
        if (props.user.role === "4") {
          response = await adminService.noticeGraph(payload);
        } else {
          response = await roleAction.noticeGraphByRole(payload);
        }
      } else if (reportType === "अटक रजिस्टर") {
        if (props.user.role === "4") {
          response = await adminService.arrestGraph(payload);
        } else {
          response = await roleAction.arrestGraphByRole(payload);
        }
      } else if (reportType === "गुन्हा रजिस्टर") {
        if (props?.user.role === "4") {
          response = await adminService.gunaGraph(payload);
        } else {
          response = await roleAction.gunaGraphByRole(payload);
        }
      }

      const data = await response.json();
      console.log("response", data);
      setChartData(data?.data || []);
      setTotalCount(data?.totalRecord);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [isClear, setClear] = useState(false);
  const dataRage = async () => {
    setClear(true);
    if (startDate && endDate) {
      const { cityId, role } = props.user;
      let payload;
      if (role == "4") {
        payload = {
          cityId: cityId,
          label: "date selected",
          start_date:
            reportType === "अटक रजिस्टर"
              ? moment(startDate)
              : moment(startDate).format("YYYY-MM-DD"),
          end_date:
            reportType === "अटक रजिस्टर"
              ? moment(endDate)
              : moment(endDate).format("YYYY-MM-DD"),
        };
      } else {
        payload = {
          districtId: props.user.map_districtId,
          label: "date selected",
          start_date:
            reportType === "अटक रजिस्टर"
              ? moment(startDate)
              : moment(startDate).format("YYYY-MM-DD"),
          end_date:
            reportType === "अटक रजिस्टर"
              ? moment(endDate)
              : moment(endDate).format("YYYY-MM-DD"),
        };
      }
      try {
        let response;
        if (reportType === "पो स्टे हद्दीतील आरोपी") {
          if (role === "4") {
            response = await professionalAction.filledPoliceStationDaily(
              payload
            );
          } else {
            response = await roleAction.filledPoliceStationDailyByRole(payload);
          }
        } else if (reportType === "पो स्टे नी भरलेली माहिती") {
          if (role === "4") {
            response = await professionalAction.notFilledPoliceStationDaily(
              payload
            );
          } else {
            response = await roleAction.notFilledPoliceStationDailyByRole(
              payload
            );
          }
        } else if (reportType === "एकुण २ प्लस आरोपी") {
          if (role === "4") {
            response = await professionalAction.totaltwoplusCount(payload);
          } else {
            response = await roleAction.totaltwoplusCountByRole(payload);
          }
        } else if (reportType === "एकुण प्रतिबंधक कारवाई") {
          if (role === "4") {
            response = await professionalAction.preventionActionCount(payload);
          } else {
            response = await roleAction.preventionActionCountByRole(payload);
          }
        } else if (reportType === "गस्त") {
          if (role === "4") {
            response = await professionalAction.surveillanceCount(payload);
          } else {
            response = await roleAction.surveillanceCountByRole(payload);
          }
        } else if (reportType === "ऐप वापरकर्ते") {
          if (role === "4") {
            response = await professionalAction.totalappuserCount(payload);
          } else {
            response = await roleAction.totalappuserCountByRole(payload);
          }
        } else if (reportType === "नोटीस रजिस्टर") {
          if (role === "4") {
            response = await adminService.noticeGraph(payload);
          } else {
            response = await roleAction.noticeGraphByRole(payload);
          }
        } else if (reportType === "अटक रजिस्टर") {
          if (props.user.role === "4") {
            response = await adminService.arrestGraph(payload);
          } else {
            response = await roleAction.arrestGraphByRole(payload);
          }
        } else if (reportType === "गुन्हा रजिस्टर") {
          if (props?.user.role === "4") {
            response = await adminService.gunaGraph(payload);
          } else {
            response = await roleAction.gunaGraphByRole(payload);
          }
        }
        const data = await response.json();
        console.log("response", data);
        setDataRange(true);
        setChartData(data?.data || []);
        setTotalCount(data?.totalRecord);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setClear(false);
      } finally {
        // setLoading(false);
      }
    }
  };

  const handleChangeRadio = (e) => {
    setSelectedValue(e.target.value);
  };

  const clearDataRange = () => {
    setDataRange(false);
    setSelectedValue(t("today"));
    setStartDate(null);
    setendDate(null);
    setClear(false);
    setSelectedDates(null);
  };

  const renderChart = () => {
    console.log("chartData", chartData);

    if (!chartData || chartData.length === 0) {
      return <p>No data available</p>;
    }

    let dataKey = "";
    let color = "";
    let labelName = "";
    if (reportType === "पो स्टे हद्दीतील आरोपी") {
      dataKey = "totalCriminals";
      color = " #00bdd0";
      // labelName = t("info_within_police_station_limits");
    } else if (reportType === "पो स्टे नी भरलेली माहिती") {
      dataKey = "totalCriminals";
      color = " #00d596";
      // labelName = t("data_entered_by_police_station");
    } else if (reportType === "ऐप वापरकर्ते") {
      dataKey = "total_app_user";
      color = " #5c78f1";
      // labelName = t("app_users");
    } else if (reportType === "एकुण २ प्लस आरोपी") {
      dataKey = "totalCrimeRecords";
      color = " #f7ca99";
      // labelName = t("total_2_plus_accused");
    } else if (reportType === "एकुण प्रतिबंधक कारवाई") {
      dataKey = "totalCrimeRecords";
      color = " #ef9ddf";
      // labelName = t("total_2_plus_accused");
    } else if (reportType === "गस्त") {
      dataKey = "totalCrimeRecords";
      color = " #fa508e";
      // labelName = t("patrol");
    } else if (reportType === "नोटीस रजिस्टर") {
      dataKey = "totalCriminals";
      color = " #27F5A3";
      // labelName = t("patrol");
    } else if (reportType === "अटक रजिस्टर") {
      dataKey = "totalCriminals";
      color = " #DFEB31";
      // labelName = t("patrol");
    } else if (reportType === "गुन्हा रजिस्टर") {
      dataKey = "totalCriminals";
      color = " #E09DDC";
    }
    if (!dataKey) {
      return <p>Invalid data format</p>;
    }

    const chartContainerStyle = {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      marginTop: "20px",
      marginBottom: "15%",
    };

    return (
      <>
        <div style={chartContainerStyle}>
          <BarChart
            width={1200}
            height={500}
            data={chartData}
            margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="policeThane"
              interval={0}
              tick={{ fontSize: 12, angle: -45, textAnchor: "end" }}
            />
            <YAxis />
            <Tooltip />
            <Bar dataKey={dataKey} name="" fill={color} barSize={15} />
          </BarChart>
        </div>
        <div>
          <p>
            {startDate && endDate && `${t("duration")}-`}

            {
              <>
                {startDate && endDate && (
                  <div style={{ marginTop: "5px" }}>
                    {moment(startDate).format("DD/MM/YYYY")} To{" "}
                    {moment(endDate).format("DD/MM/YYYY")}
                  </div>
                )}
                {selectedValue == t("today") ? (
                  <>{moment().format("DD/MM/YYYY")}</>
                ) : selectedValue == t("monthly") ? (
                  <>
                    {moment().format("MMM")}'{moment().year()}
                  </>
                ) : selectedValue == t("six_months") ? (
                  <>
                    {moment().subtract(6, "months").format("MMM'YYYY")} To{" "}
                    {moment().format("MMM'YYYY")}
                  </>
                ) : selectedValue == t("one_year") ? (
                  <>{moment().format("YYYY")}</>
                ) : (
                  ""
                )}
              </>
            }
          </p>
          {selectedValue == t("all") ? (
            <>
              <>{t("all")}</>
            </>
          ) : (
            ""
          )}
        </div>
      </>
    );
  };

  const [selectedDates, setSelectedDates] = useState(null);
  const onSelectDate = (values) => {
    setSelectedValue(null);
    if (values) {
      setStartDate(values[0]);
      setendDate(values[1]);
      setSelectedDates(values); // ✅ Store dayjs objects to keep value in RangePicker
    }
  };
  const handleDownloadImage = () => {
    const element = document.getElementById("image");

    if (!element) {
      console.error("Element not found.");
      return;
    }

    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.95);

      const link = document.createElement("a");
      link.href = imgData;
      const report_name =
        reportType == "पो स्टे हद्दीतील आरोपी"
          ? t("info_within_police_station_limits")
          : reportType == "पो स्टे नी भरलेली माहिती"
          ? t("data_entered_by_police_station")
          : reportType == "एकुण २ प्लस आरोपी"
          ? t("total_2_plus_accused")
          : reportType == "एकुण प्रतिबंधक कारवाई"
          ? t("total_preventive_actions")
          : reportType == "गस्त"
          ? t("patrol")
          : reportType === "ऐप वापरकर्ते"
          ? t("app_users")
          : reportType === "नोटीस रजिस्टर"
          ? t("notice_register")
          : reportType === "अटक रजिस्टर" && t("arrest_register");

      link.download = `Report_${report_name}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const initialValues = {
    report_type: "पो स्टे हद्दीतील आरोपी",
  };

  const handleValuesChange = (changedValues, allValues) => {
    setReportType(allValues?.["report_type"]);
    setChartData([]);
  };

  console.log("reportType", reportType);
  console.log("isclear", isClear);
  return (
    <>
      <Form
        form={form}
        initialValues={initialValues}
        onValuesChange={handleValuesChange}
      >
        <Row gutter={16} style={{ marginLeft: "2px" }}>
          <Col span={8}>
            <Form.Item
              name="report_type"
              rules={[{ required: true, message: "Please select a value" }]}
            >
              <Select placeholder="Please select value">
                {options.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row>
        <Button
          type="primary"
          icon={<FileImageOutlined />}
          onClick={handleDownloadImage}
          style={{ float: "right", marginTop: "-6.5%", marginLeft: "96%" }}
        />
      </Row>
      <div id="image">
        <Row>
          <Col style={{ width: "100%", textAlign: "center" }}>
            {loading ? (
              <Spin size="large" style={{ margin: "50px 0" }} />
            ) : chartData.length > 0 ? (
              <>
                <div style={{ fontWeight: "bold" }}>
                  {reportType == "पो स्टे हद्दीतील आरोपी"
                    ? t("info_within_police_station_limits")
                    : reportType == "पो स्टे नी भरलेली माहिती"
                    ? t("data_entered_by_police_station")
                    : reportType == "एकुण २ प्लस आरोपी"
                    ? t("total_2_plus_accused")
                    : reportType == "एकुण प्रतिबंधक कारवाई"
                    ? t("total_preventive_actions")
                    : reportType == "गस्त"
                    ? t("patrol")
                    : reportType === "ऐप वापरकर्ते"
                    ? t("app_users")
                    : reportType === "नोटीस रजिस्टर"
                    ? t("notice_register")
                    : reportType === "अटक रजिस्टर" && t("arrest_register")}
                </div>
                <p>
                  {t("count")}-{totalCount && totalCount}
                </p>
                {renderChart()}
              </>
            ) : (
              <p>No data available</p>
            )}
          </Col>
        </Row>
      </div>
      <Row style={{ margin: "10px" }} justify="space-between" align="middle">
        <Col style={{ display: "flex", marginLeft: "7%" }}>
          <div style={{ marginTop: "1%", fontWeight: "bold" }}>
            {t("duration")} :{" "}
          </div>
          <Radio.Group
            onChange={handleChangeRadio}
            value={selectedValue}
            buttonStyle="solid"
            className="time-range-selector"
            style={{ marginLeft: "10px" }}
            disabled={dateRange == true}
          >
            {timeRange.map((option) => (
              <Radio.Button
                key={option}
                value={option}
                className="time-range-button"
              >
                {option}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Col>
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <RangePicker value={selectedDates} onChange={onSelectDate} />
          {isClear == true && (
            <Button
              className="modern-button modern-button-danger margin-left-1"
              key="1"
              type="primary"
              onClick={() => {
                clearDataRange();
              }}
            >
              {t("clear")}
            </Button>
          )}
        </Col>
      </Row>
    </>
  );
};

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  console.log("user", user);
  const { pc_cities, basicDistricts } = professionals;
  return {
    user,
    users,
    pc_cities,
    basicDistricts,
  };
}

const connectedAnalyticalDashboard =
  connect(mapStateToProps)(AnalyticalDashboard);
export { connectedAnalyticalDashboard as AnalyticalDashboard };
